import { Privileges } from "./PrivilegeConstants";

export const ADS_SPONSORSHIP_FEATURE = "ADS_SPONSORSHIP";

export const ADS_PRIVILEGE_KEYS = [
    Privileges.ADS_SPONSORSHIP.MANAGE_SPONSOR,
    Privileges.ADS_SPONSORSHIP.MANAGE_SPONSORSHIP,
    Privileges.ADS_SPONSORSHIP.MANAGE_SPONSORSHIP_PAYMENT,
    Privileges.ADS_SPONSORSHIP.MANAGE_ADVERTISEMENT,
    Privileges.ADS_SPONSORSHIP.MANAGE_AD_ANALYTICS,
];

export const ADS_CONFIG_KEYS = [
    Privileges.ADS_SPONSORSHIP.MANAGE_SPONSOR,
    Privileges.ADS_SPONSORSHIP.MANAGE_SPONSORSHIP,
    Privileges.ADS_SPONSORSHIP.MANAGE_SPONSORSHIP_PAYMENT,
    Privileges.ADS_SPONSORSHIP.MANAGE_ADVERTISEMENT,
];

export const ADS_TABS = [
    { name: "Sponsors", subFeature: Privileges.ADS_SPONSORSHIP.MANAGE_SPONSOR },
    { name: "Deals", subFeature: Privileges.ADS_SPONSORSHIP.MANAGE_SPONSORSHIP },
    { name: "Banners", subFeature: Privileges.ADS_SPONSORSHIP.MANAGE_ADVERTISEMENT },
    { name: "Campaigns", subFeature: Privileges.ADS_SPONSORSHIP.MANAGE_ADVERTISEMENT },
    { name: "Preview", subFeature: Privileges.ADS_SPONSORSHIP.MANAGE_ADVERTISEMENT },
    { name: "Payments", subFeature: Privileges.ADS_SPONSORSHIP.MANAGE_SPONSORSHIP_PAYMENT },
];

export const canAccessAdsSponsorship = (privilegeList = []) =>
    ADS_CONFIG_KEYS.some((key) => privilegeList?.includes(key));

export const hasAdsAction = (privileges, subFeature, action) =>
    Boolean(privileges?.[subFeature]?.includes(action));

export const canViewAdsTab = (privileges, subFeature) =>
    hasAdsAction(privileges, subFeature, Privileges.VIEW);

export const canAccessAdsFromPrivileges = (privileges = {}) =>
    ADS_CONFIG_KEYS.some((key) => canViewAdsTab(privileges, key));

export const canViewAdsAnalytics = (privileges = {}) =>
    canViewAdsTab(privileges, Privileges.ADS_SPONSORSHIP.MANAGE_AD_ANALYTICS);

export const visibleAdsTabs = (privileges) =>
    ADS_TABS.filter((tab) => canViewAdsTab(privileges, tab.subFeature));
